import { computed, makeObservable } from 'mobx';
import { JobFormManager } from '../job-form.manager';

export class SalaryGroupViewModel {
   constructor(readonly jobManager: JobFormManager) {
      makeObservable(this, {
         currencies: computed,
         currencyRequired: computed,
      });
   }

   get currencies(): { value: string; viewValue: string }[] {
      const jobAttr = this.jobManager.jobAttributes.get();
      if (jobAttr) {
         return Object.entries(jobAttr.currencies).map(([k, v]) => ({
            value: k,
            viewValue: v,
         }));
      }
      return [];
   }

   get currencyRequired(): boolean {
      return (
         !!this.jobManager.form.controls['salary_min'].value ||
         !!this.jobManager.form.controls['salary_max'].value
      );
   }
}
